import React from "react";
import { Button, Tooltip } from "antd";
import History from "../../../assets/images/history.svg";
import DisabledHistory from "../../../assets/images/disabled-history.svg";
import { Colors } from "../../../theme";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
import { gaEvent } from "../../../analytics/analytics";
import * as GA from "../../../constants/analytics";
import DashboardCard from "./Card";

export default function HistoryCard({ allowed }) {
  const history = useHistory();
  const SeeCatalougueCard = styled.div`
    .card {
      margin-right: 1rem;
      min-height: 25em;
      max-height: 100%;
      margin-top: 0.5rem;
      padding: 1rem;
      border-radius: 0.5rem;
      &:hover {
        background: ${allowed && "#fafcf5"};
        cursor: ${allowed && "pointer"};
      }
      @media (max-width: 400px) {
        padding: 0rem;
      }
    }
  `;
  const handleClick = () => {
    if (allowed) {
      history.push("/catalogue-history");
      gaEvent(
        GA.EVENT.CLICK,
        GA.CATEGORY.COLLECTION_INSIGHTS,
        GA.DESCRIPTION.COLLECTION_INSIGHTS_CARD
      );
    }
  };
  return (
    <Tooltip
      trigger="hover"
      // visible={!allowed}
      title={!allowed && "You don’t have permission to view all catalogues"}
    >
      <SeeCatalougueCard>
        <DashboardCard
          allowed={allowed}
          onClick={handleClick}
          icon={
            <img
              src={allowed ? History : DisabledHistory}
              alt="catlougue"
              height={"64px"}
              width={"64px"}
            />
          }
          title="All Catalogues"
          subTitle=" You can see all the catalogues, both active and draft, that
          you have created"
          cta={
            <Button
              size="large"
              style={{
                padding: 0,
              }}
              type={"link"}
              disabled={!allowed}
              onClick={() => {
                gaEvent(
                  GA.EVENT.CLICK,
                  GA.CATEGORY.CREATE_COLLECTION,
                  GA.DESCRIPTION.CREATE_COLLECTION_BUTTON
                );
              }}
            >
              See all catalogues
            </Button>
          }
        />
      </SeeCatalougueCard>
    </Tooltip>
  );
}
